// import Vue from 'vue'
// import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

const Vue = window.Vue
const VueRouter = window.VueRouter
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
    },
    {
        path: '/solution/tongyijia',
        name: 'tongyijia',
        component: () => import(/* webpackChunkName: "solution" */ '../views/solution/tongyijia.vue')
    }, {
        path: '/solution/tongsuanCloud',
        name: 'tongsuanCloud',
        component: () => import(/* webpackChunkName: "solution" */ '../views/solution/tongsuanCloud.vue')
    },
    {
        path: '/solution/functionalAdditives',
        name: 'functionalAdditives',
        component: () => import(/* webpackChunkName: "solution" */ '../views/solution/functionalAdditives.vue')
    }, {
        path: '/development/innovation',
        name: 'innovation',
        component: () => import(/* webpackChunkName: "development" */ '../views/development/innovation.vue')
    }, {
        path: '/development/breakthroughs',
        name: 'breakthroughs',
        component: () => import(/* webpackChunkName: "development" */ '../views/development/breakthroughs.vue')
    }, {
        path: '/brand/index',
        name: 'brand',
        component: () => import(/* webpackChunkName: "brand" */ '../views/brand/index.vue')
    }, {
        path: '/newsAndEvents/index',
        name: 'newsAndEvents',
        component: () => import(/* webpackChunkName: "newsAndEvents" */ '../views/newsAndEvents/index.vue')
    },
    {
        path: '/newsDetails',
        name: 'details',
        component: () => import(/* webpackChunkName: "details" */ '../views/details/index.vue')
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/agreement',
        name: 'index',
        component: () => import(/* webpackChunkName: "details" */ '../views/agreement/index.vue')
    },
]

const router = new VueRouter({
    mode: 'history', // 使用 history 模式
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // 如果有保存的位置（如点击浏览器的前进/后退按钮）
            return savedPosition
        } else {
            // 否则，滚动到顶部
            return {x: 0, y: 0}
        }
    }
})
// 加入百度统计
router.beforeEach((to, from, next) => {
    if (to.path) {
        if (window._hmt) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    next()
})

export default router
